import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IMultiLineBehavior } from "../../../../documaker/domain/format/objects";

export interface IMultiLineBehaviorPropertyEditable {
  multiLineBehavior(): IPropertyEditable<IMultiLineBehavior>;
}

export function instanceOfIMultiLineBehaviorPropertyEditable(instance: any): instance is IMultiLineBehaviorPropertyEditable {
  return instance
      && instance.multiLineBehavior
      && instanceOfIPropertyEditable<IMultiLineBehavior>(instance.multiLineBehavior());
}
